import { useState } from "react";
import { Button, Input, Form, message } from "antd";
import LockIcon from "../../assets/images/input-icons/lock-icon.svg";
import { CheckOutlined } from "@ant-design/icons";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath"; // Assuming you have API paths defined
import { useNavigate } from "react-router-dom"; // For navigation after logout

function ChangePassIndex() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { request } = useRequest();

  const handlePasswordUpdate = (values) => {
    // Validate if new password and confirm password match
    if (values.new_password !== values.confirm_password) {
      message.error("New password and confirm password do not match");
      return;
    }

    setLoading(true);
    request({
      url: apiPath.changePassword,
      method: 'POST',
      data: {
        old_password: values.old_password,
        new_password: values.new_password
      },
      onSuccess: () => {
        message.success('Password updated successfully. Please sign in again with your new password.');

        // Set a short timeout to show the success message before logout
        setTimeout(() => {
          // Clear any auth tokens from localStorage
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          navigate('/sign-in');
        }, 1500); // Short delay to show the success message
      },
      onError: (error) => {
        console.log(error, "error")
        const errorMessage = error?.response?.data?.message || 'Failed to update password';
        message.error(errorMessage);
        setLoading(false);
      }
    });
  };

  const validatePassword = (_, value) => {
    // Basic password validation - at least 8 characters
    if (value && value.length < 8) {
      return Promise.reject(new Error("Password must be at least 8 characters"));
    }
    return Promise.resolve();
  };

  return (
    <div className="profile-container">
      <h2 className="profile-title">Change Password</h2>
      <div className="profile-detail-card01">
        <div className="change-pass-headding">
          <h6>Change Password</h6>
        </div>
        <div className="profile-detail-card01">
          <Form
            form={form}
            layout="vertical"
            onFinish={handlePasswordUpdate}
          >
            <Form.Item
              label="Enter current password"
              name="old_password"
              rules={[
                { required: true, message: "Please enter your current password" }
              ]}
              normalize={(value) => value.trimStart()}
            >
              <div className="name-select-main">
                <img src={LockIcon} alt="Lock Icon" />
                <Input.Password placeholder="Enter current password" />
              </div>
            </Form.Item>

            <Form.Item
              label="Enter new password"
              name="new_password"
              rules={[
                { required: true, message: "Please enter your new password" },
                {
                  pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/),
                  message: "Password must contain at least one uppercase, one lowercase, one number, and one special character!",
                },
                // { validator: validatePassword }
              ]}
              normalize={(value) => value.trimStart()}
            >
              <div className="name-select-main">
                <img src={LockIcon} alt="Lock Icon" />
                <Input.Password placeholder="Enter new password" />
              </div>
            </Form.Item>

            <Form.Item
              label="Confirm new password"
              name="confirm_password"
              dependencies={['new_password']}
              rules={[
                { required: true, message: "Please confirm your new password" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('new_password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('The two passwords do not match'));
                  },
                }),
              ]}
              normalize={(value) => value.trimStart()}
            >
              <div className="name-select-main">
                <img src={LockIcon} alt="Lock Icon" />
                <Input.Password placeholder="Confirm new password" />
              </div>
            </Form.Item>

            <Button
              type="primary"
              className="fill-btn"
              htmlType="submit"
              loading={loading}
              icon={loading ? null : <CheckOutlined />}
            >
              Update Password
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default ChangePassIndex;